/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Organizationslug2Inputs */

const zh_organizationsettings_organizationslug2 = /** @type {(inputs: Organizationsettings_Organizationslug2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`组织标识`)
};

const en_organizationsettings_organizationslug2 = /** @type {(inputs: Organizationsettings_Organizationslug2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization Slug`)
};

const es_organizationsettings_organizationslug2 = /** @type {(inputs: Organizationsettings_Organizationslug2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slug de la organización`)
};

/**
* | output |
* | --- |
* | "Organization Slug" |
*
* @param {Organizationsettings_Organizationslug2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_organizationslug2 = /** @type {((inputs?: Organizationsettings_Organizationslug2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Organizationslug2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_organizationslug2(inputs)
	if (locale === "en") return en_organizationsettings_organizationslug2(inputs)
	return es_organizationsettings_organizationslug2(inputs)
});
export { organizationsettings_organizationslug2 as "organizationSettings_organizationSlug" }